import { Calendar, Home, Shield } from 'lucide-react';

import { DisplayYear } from '@src/components/RealDate.jsx';
import { useNavigateToTop } from '@src/hooks/useNavigateToTop';
// Removed the interface definition for NotFoundPageProps

export function NotFoundComponent() {
  const onNavigateToTop = useNavigateToTop();
  return (
    <div className="relative min-h-screen bg-white overflow-hidden">
      {/* Minimal Background Accents */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Very subtle blue shapes */}
        <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-[#1e638d] rounded-full opacity-5 blur-2xl" />
        <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-[#1e638d] rounded-full opacity-3 blur-3xl" />
      </div>

      {/* Main Content Container */}
      <div className="relative z-10 flex flex-col min-h-screen">
        {/* Hero Section - Centered */}
        <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            {/* Shield Watermark - Very Subtle */}
            <div className="relative">
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-[0.03]">
                <Shield
                  strokeWidth={0.5}
                  className="w-96 h-96 text-[#1e638d]"
                />
              </div>

              {/* Error Code */}
              <p style={{ color: '#1e638d' }} className="text-9xl font-extrabold mb-4">
                404
              </p>
            </div>

            {/* Title */}
            <h1 className="text-5xl sm:text-6xl font-extrabold text-gray-900 mb-6">
              Page Not Found
            </h1>

            {/* Subtitle */}
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-6 leading-tight">
              Oops! The page you&apos;re looking for doesn&apos;t exist.
            </h2>

            {/* Description */}
            <p className="text-lg text-gray-600 mb-12 leading-relaxed max-w-md mx-auto">
              Don&apos;t worry, your security isn&apos;t lost. Let&apos;s get
              you back on track.
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                className={
                  'group bg-[#1e638d] hover:bg-[#1a5a7a] text-white px-8 py-4 rounded-lg font-medium transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-[#1e638d]/20 flex items-center gap-3 min-w-[200px] '
                  + 'justify-center'
                }
                onClick={() => onNavigateToTop('/contact')}
              >
                <Calendar className="w-5 h-5" />
                Contact
              </button>

              <button
                className={
                  'group border-2 border-[#1e638d] text-[#1e638d] hover:bg-[#1e638d] hover:text-white px-8 py-4 rounded-lg font-medium '
                  + 'transition-all duration-300 hover:scale-[1.02] flex items-center gap-3 min-w-[200px] justify-center'
                }
                onClick={() => onNavigateToTop('/')}
              >
                <Home className="w-5 h-5 group-hover:text-white transition-colors duration-300" />
                Go to Homepage
              </button>
            </div>
          </div>
        </div>

        {/* Footer Text */}
        <div className="p-4 text-center text-sm text-gray-500">
          ©
          {' '}
          <DisplayYear />
          {' '}
          SecureOneLabs — BOSSS Back Office Security Supervisory System
        </div>
      </div>
    </div>
  );
}
